import { isArray } from "../utils"

export const PEERS = "peers"
export const ALL = "all"
export const TOP10 = "top10"

export type GroupProps = {
  key: string
  name: string
  isGlobal: boolean
}

export class Group {
  private group: string
  private customGroups: GroupProps[]

  private fund_groups: GroupProps[] = [
    { key: PEERS, name: "Peers by Grafiniti", isGlobal: true },
    { key: ALL, name: "Category", isGlobal: true },
    { key: TOP10, name: "Top10", isGlobal: true },
  ]

  private firm_groups: GroupProps[] = [
    { key: PEERS, name: "Peers by Grafiniti", isGlobal: true },
    { key: ALL, name: "Industry", isGlobal: true },
    { key: TOP10, name: "Top10", isGlobal: true },
  ]

  constructor(group: string, customGroups: GroupProps[]) {
    this.group = group
    this.customGroups = customGroups
  }

  getGroup() {
    return this.group
  }

  getGroups(isFund: boolean) {
    let groups = isFund ? this.fund_groups : this.firm_groups
    const isThereCustomGroups = this.customGroups.length > 0

    if (isThereCustomGroups) {
      return [...groups, ...this.customGroups]
    } else return groups
  }

  getCustomGroups() {
    return this.customGroups
  }

  setGroup(group: string) {
    this.group = group
  }

  setCustomGroups(customGroups: GroupProps[]) {
    this.customGroups = customGroups
  }

  getGroupName(isFund: boolean) {
    const groups = this.getGroups(isFund)
    const thisGroup = isArray(this.group) ? this.group[0] : this.group
    const groupFound = groups.find((g) => g.key === thisGroup)

    if (!groupFound) throw new Error(`Invalid group: ${this.group}`)
    return groupFound.name
  }

  getGroupNameByKey(isFund: boolean, key: string) {
    const groups = this.getGroups(isFund)
    const groupFound = groups.find((g) => g.key === key)

    if (!groupFound) throw new Error(`Invalid group key: ${key}`)
    return groupFound.name
  }

  isPeers() {
    return this.group == PEERS
  }

  isAll() {
    return this.group == ALL
  }

  isTop10() {
    return this.group == TOP10
  }

  isCustomGroup() {
    return !this.isAll() && !this.isTop10() && !this.isPeers()
  }

  resetCustomGroups() {}
}
